document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM fully loaded and parsed'); // Debugging log

  const sizeOrder = [
    '0-3 MND', '0-6 MND', '3-6 MND', '6-12 MND', '12-24 MND',
    '0-1 JAAR', '1-2 JAAR', '2-4 JAAR', '3-6 JAAR', '5-8 JAAR', '6-8 JAAR',
    '56-62', '68-74', '80-86', '92-98', '104-110', '116-122', '128-134', '140-146',
    'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL',
    'XXS/XS', 'XS/S', 'S/M', 'M/L', 'L/XL', 'XL/XXL',
    '21-22', '23-24', '25-26', '27-28', '29-30', '31-32', '33-34',
    '35-36', '37-38', '39-40', '41-42', '43-44', '45-46',
    '36-39', '40-43', '44-47',
    '60X120CM', '75X100CM', '90X200CM', '100X140CM', '100X150CM', '140X200CM', '150X200CM', '160X200CM', '180X200CM',
    '44-46', '44-50', '48-50', '52-58', '52-54', '56-58', '60-62',
    'ONE', '80X42CM', '14CM', '16.5CM', '18.5CM', '32CM', '38CM', '45CM',
    'F24-25', 'F26-27', 'F28-29', 'F30-31', 'F32-33', 'F34-35',
    'F35-36', 'F36-37', 'F37-38', 'F38-39', 'F39-40', 'F40-41', 'F42-43', 'F44-45'
  ];

  const expandedSizeOrder = {
    '0-6/6-12M': ['0-6 MND', '6-12 MND'],
    '0-6/12-24M': ['0-6 MND', '6-12 MND', '12-24 MND'],
    '0-3/3-6M': ['0-3 MND', '3-6 MND'],
    '0-6/6Y': ['0-6 MND', '6-12 MND', '12-24 MND', '3-6 JAAR'],
    '68-98': ['68-74', '80-86', '92-98'],
    '92-146': ['92-98', '104-110', '116-122', '128-134', '140-146'],
    '104-146': ['104-110', '116-122', '128-134', '140-146'],
    'XS-XXL': ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    'XS-XL': ['XS', 'S', 'M', 'L', 'XL'],
    'S-M-L': ['S', 'M', 'L'],
    'XS-5XL': ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'],
    'XXS/XS-L/X': ['XXS/XS', 'S/M', 'L/XL'],
    'XS/S-M/L': ['XS/S', 'M/L'],
    'XS/S-XXL': ['XS/S', 'M/L', 'XL/XXL'],
    'S/M-L/XL': ['S/M', 'L/XL'],
    '21-34': ['21-22', '23-24', '25-26', '27-28', '29-30', '31-32', '33-34'],
    '25-34': ['25-26', '27-28', '29-30', '31-32', '33-34'],
    '35-46': ['35-36', '37-38', '39-40', '41-42', '43-44', '45-46'],
    '36-47': ['36-39', '40-43', '44-47'],
    'DEKENS 1': ['75X100CM', '100X140CM', '140X200CM'],
    'DEKENS 2': ['75X100CM', '100X150CM', '150X200CM'],
    'WIEG': ['80X42CM'],
    'MATRAS': ['60X120CM', '90X200CM', '160X200CM', '180X200CM'],
    'HOOFD KIDS': ['44-46', '48-50', '52-54'],
    'HOOFD VOLW': ['56-58', '60-62'],
    'HOOFD ALL': ['44-46', '48-50', '52-54', '56-58', '60-62'],
    'XXS/S': ['XXS', 'XS', 'S'],
    'XXS/L': ['XXS', 'XS', 'S', 'M', 'L'],
    '6-12/12-24': ['6-12 MND', '12-24 MND'],
    '80-146': ['80-86', '92-98', '104-110', '116-122', '128-134', '140-146'],
    'XS-L': ['XS', 'S', 'M', 'L'],
    'S-XL': ['S', 'M', 'L', 'XL'],
    'M-XL': ['M', 'L', 'XL'],
    '80-134': ['80-86', '92-98', '104-110', '116-122', '128-134'],
    'S-XXL': ['S', 'M', 'L', 'XL', 'XXL'],
    'M-L': ['M', 'L'],
    'HOOFD 1': ['44-46', '48-50', '52-54', '56-58'],
    '44-58': ['44-50', '52-58'],
    'JAREN': ['1-2 JAAR', '2-4 JAAR', '5-8 JAAR'],
    '80-122': ['80-86', '92-98', '104-110', '116-122'],
    '21-26': ['21-22', '23-24', '25-26'],
    '35-44': ['35-36', '37-38', '39-40', '41-42', '43-44'],
    '36/47': ['36-39', '40-43', '44-47'],
    '116-146': ['116-122', '128-134', '140-146'],
    '68-110': ['68-74', '80-86', '92-98', '104-110'],
    'FKIDS': ['F24-25', 'F26-27', 'F28-29', 'F30-31', 'F32-33', 'F34-35'],
    'FVOLW': ['F35-36', 'F36-37', 'F37-38', 'F38-39', 'F39-40', 'F40-41', 'F42-43'],
    'FVOLWXL': ['F35-36', 'F36-37', 'F37-38', 'F38-39', 'F39-40', 'F40-41', 'F42-43', 'F44-45'],
    '0-3/6-12M': ['0-3 MND', '3-6 MND', '6-12 MND'],
    '68-134': ['68-74', '80-86', '92-98', '104-110', '116-122', '128-134'],
    '56-98': ['56-62', '68-74', '80-86', '92-98'],
    '56-86': ['56-62', '68-74', '80-86'],
    'XXS/XS S/M': ['XXS/XS', 'S/M']
  };

  const sortSizes = (labels) => {
    return labels.sort((a, b) => {
      const sizeA = a.querySelector('.text').textContent.trim().toUpperCase();
      const sizeB = b.querySelector('.text').textContent.trim().toUpperCase();

      const expandedSizeA = expandedSizeOrder[sizeA] ? expandedSizeOrder[sizeA][0] : sizeA;
      const expandedSizeB = expandedSizeOrder[sizeB] ? expandedSizeOrder[sizeB][0] : sizeB;

      return sizeOrder.indexOf(expandedSizeA) - sizeOrder.indexOf(expandedSizeB);
    });
  };

  const moveAndSortLabels = (container) => {
    const sizeLabels = container.querySelectorAll('label.product-form__label.available');
    if (sizeLabels.length > 0) {
      const sortedLabels = sortSizes(Array.from(sizeLabels));
      sortedLabels.forEach(label => {
        const radio = container.querySelector(`#${label.getAttribute('for')}`);
        if (radio) {
          container.appendChild(radio);
          container.appendChild(label);
        }
      });
    }
  };

  // Sort sizes on the main product page
  const mainContainer = document.querySelector('.product-form__input');
  if (mainContainer) {
    moveAndSortLabels(mainContainer);
  }

  // Sort sizes in the popup
  const observePopup = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(addedNode) {
        if (addedNode.nodeType === Node.ELEMENT_NODE) {
          const popupContainer = addedNode.querySelector('.product-edit-options .product-form__input');
          if (popupContainer) {
            moveAndSortLabels(popupContainer);
          }
        }
      });
    });
  });

  // Start observing the body for added nodes (popups)
  observePopup.observe(document.body, { childList: true, subtree: true });
});
